import axios from "axios";
import { Message } from "element-ui";
import { qsParse } from '@/utils/qs';
import { filterObjWithValidValue } from '@/api/url';
import { getXTSessionid } from "@/utils/project";
import md5 from "js-md5";
import { clearLogin } from "@/api/base/request";

// 接口地址
// axios.defaults.baseURL = 'http://192.168.1.204:8081/api';
// axios.defaults.baseURL = "http://wisdomcloud-test.heiniubao.cn";
// 设置超时时间和跨域
//http request 拦截器
axios.interceptors.request.use(
  (config) => {
    // 正式Ip
    // let IPOptions = getQueryString('ip') ? {'X-IP-Header': getQueryString('ip')} : {}
    // 测试修改---测试完成删除
    config.headers = {
      "token2": localStorage.getItem("token2"),
      "Content-Type": "application/json",
      'USER-TOKEN': 'skip',
      'deviceId': localStorage.getItem('device_id'),
      "x-t-sessionid": getXTSessionid(),
      "X-Request-Id": md5(new Date().getTime() + "-" + Math.random()),
    };

    // 使用链接上的token （用于不登录直接访问的页面）
    // https://wisdomcloud-test.heiniubao.cn/preview/mttf/zx-to-mofang?token=FisLPbXDTWWkIpwe68JfeTHaplWNKv6
    const query = qsParse();
    if (query.token) config.headers.token2 = query.token;

    const blueToken = localStorage.getItem('blueToken');
    if (blueToken) config.headers.token2 = blueToken;
    if (config.url.includes('policy/rbLogin')) config.headers.scene = 'zhibaoyun';

    // --------------------------
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == "666666") {
      Message.warning({ message: "登录超时", duration: 1500 });
      clearLogin();
      window.location.replace(`/login?redirectUrl=${encodeURIComponent(window.location.href)}`);
    }
    if (response.data.code && response.data.code != "000000" && response.data.code != "666666") {
      Message.warning({ message: response.data.message, duration: 1500 });
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}, opt={}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: filterObjWithValidValue(params),
        ...opt
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        Message.error({ message: "服务超时,请稍后重试", duration: 1500 });
        reject(err);
      });
  });
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, originData = {}, options={}) {
  return new Promise((resolve, reject) => {
    let data = filterObjWithValidValue(originData);
    if (options.noValid) data = originData;
    axios.post(url, JSON.stringify(data)).then(response => {
      resolve(response.data);
    }).catch(err => {
      Message.error({ message: "服务超时,请稍后重试", duration: 1500 });
      reject(err);
    })
  });
}

export function post2(url, params={}, options={}){
  return axios({
    method: "POST",
    url,
    data: params,
    ...options,
  })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      Message.error({ message: "服务超时,请稍后重试", duration: 1500 });
      return Promise.reject(err);
    });
}

